import { themeClubbi, useMediaQuery } from 'clubbi-ui'

import {
  StyledAbasteceShopBanner,
  StyledAbasteceShopBannerImage,
  StyledAbasteceShopBannerLink,
} from './AbasteceShopBanner.style'

const IMG_BASE = `/img/landingpage_abasteceshop/banner-abasteceshop-`
const DESKTOP_BANNER_SRC = `${IMG_BASE}desktop.png`
const MOBILE_BANNER_SRC = `${IMG_BASE}mobile.png`

export const AbasteceShopBanner = () => {
  const isDesktop = useMediaQuery(themeClubbi.breakpoints.up('md'))
  const bannerSrc = isDesktop ? DESKTOP_BANNER_SRC : MOBILE_BANNER_SRC

  return (
    <StyledAbasteceShopBanner>
      <StyledAbasteceShopBannerLink to="/redirect-abastece-shop">
        <StyledAbasteceShopBannerImage src={bannerSrc} alt="Conheca o AbasteceShop" />
      </StyledAbasteceShopBannerLink>
    </StyledAbasteceShopBanner>
  )
}
